const CACHE_KEYS = {
    AUTH: 'auth',
    REQUEST_USER: 'request-user',
    COURSES: 'courses',
    USERS: 'users',
    SETTINGS: 'settings',
    REFLECTION_PROMPTS: 'reflection-prompts',
    SURVEYS: 'surveys',
    USER_INTERESTS: 'user-interests',
    USER_GOALS: 'user-goals',
    LEARNING_RESOURCES: 'learning-resources',
    JOBS: 'jobs',
    DISCUSSIONS: 'discussions',
    MOBILE_IOS_REDEMPTIONS: 'mobile-ios-redemptions',
    USER_REFLECTIONS: 'user-reflections',
    MOBILE_ANROID_LINK: 'mobile-android-link',
    REPORTS: 'reports',
    COURSE_SURVEYS: 'course-surveys',
    FACILITATOR_SURVEYS: 'facilitator-surveys',
    COURSE_ATTENDEES: 'course-attendees',
    LOCATIONS: 'locations'
}

export default CACHE_KEYS